import { InjectionToken } from '@angular/core';

export const BRADMAX_PLAYER_CONFIGURATION = new InjectionToken<bradmax.player.Configuration>('BRADMAX_PLAYER_CONFIGURATION');

export const BRADMAX_PLAYER_DEBUG = new InjectionToken<boolean>('BRADMAX_PLAYER_DEBUG');

export const BRADMAX_PLAYER_SOURCE_PATH = new InjectionToken<string>('BRADMAX_PLAYER_SOURCE_PATH');
